import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const Horizon787MarketingSeo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="A detailed 787 Dreamliner experience">
        <Text fz="medium">
          The Horizon Simulations 787 brings one of Boeing's most advanced widebody aircraft to
          Microsoft Flight Simulator. This template covers every phase of flight, from preflight
          to parking, with procedures tailored to the Horizon 787's systems.{" "}
          <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="Make the 787 your own">
        <Text fz="medium">
          This checklist is based on{" "}
          <a
            href="https://www.youtube.com/@jaydeegaming"
            target="_blank"
            data-goatcounter-click="jaydee-youtube-link"
          >
            JayDee
          </a>
          's 787 checklist on{" "}
          <a
            href="https://msfschecklist.de"
            target="_blank"
            data-goatcounter-click="msfschecklist-link"
          >
            msfschecklist.de
          </a>{" "}
          and you can customize it to your liking using our web-based editor. Change colors
          and font sizes, add memory items that need reinforcement, or mix in reminders for your
          favorite addon software. Checklists can be exported as PDFs and are saved in your browser,
          so you can come back and adjust them later.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
